import { render, staticRenderFns } from "./MultipleAccountView.vue?vue&type=template&id=6fbb9773&scoped=true&"
import script from "./MultipleAccountView.vue?vue&type=script&lang=js&"
export * from "./MultipleAccountView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbb9773",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fbb9773')) {
      api.createRecord('6fbb9773', component.options)
    } else {
      api.reload('6fbb9773', component.options)
    }
    module.hot.accept("./MultipleAccountView.vue?vue&type=template&id=6fbb9773&scoped=true&", function () {
      api.rerender('6fbb9773', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/affiliates/MultipleAccountView.vue"
export default component.exports